export default __webpack_public_path__ + "static/media/password-star.2e38d948.svg";